import { apiCall } from "../utils/api";
export type StatementAccount = {
   id: string;
   externalId: number;
   fullName: string;
   monthlyPeriod: string;
   pointsAccumulated: number;
   pointsRedeemed: number;
   availablePoints: number;
   urlLogin: string;
   contactEmail: string;
   urlTerms: string;
 };
 export type requestStatmentAccount = {
   externalId: string|null;
   loyaltyPlanId: string|undefined;
 }
 export type requestLoyaltyPlanListStatment = {
   loyaltyPlanId?: string |null;
 }
 export interface AccountStatementBannerProps {
   id?: number;
   loyaltyPlanId: number;
   name: string;
   path: string;
   link: string;
   priorityMembersMessage: string;
   nonPriorityMembersMessage: string;
   isActive: boolean;
   isLinkEnabled: boolean;
   isEditable: boolean;
   editableInHours: number;
   image:Image
 }
 type Image = {
    name: string;
    path: string;
  };
  
  export type BaseOfferRequest = {
    id?: number;
    loyaltyPlanId: number;
    image: Image;
    isLinkEnabled: boolean;
    link: string;
    priorityMembersMessage: string;
    nonPriorityMembersMessage: string;
    isActive: boolean;
  };
  
export async function GetPartnerStatement({externalId, loyaltyPlanId}:requestStatmentAccount): Promise<StatementAccount> {
   const result = await apiCall({
      url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v1/members/by-external-id/${externalId}?loyaltyPlanId=${loyaltyPlanId}`,
      method: 'GET',
   })

   return result.data||undefined;
}
export async function getLoyaltyPlansForStatement({loyaltyPlanId}:requestLoyaltyPlanListStatment): Promise<Array<any>> {
   const result = await apiCall({
      url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v1/plans/banner`,
      method: 'GET',
   })
   return result.data|| null
}

export async function getAccountBannerConfig({loyaltyPlanId}:{loyaltyPlanId?:string|null}): Promise<AccountStatementBannerProps>{
   try {
      const result = await apiCall({
         url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v1/banner/loyaltyPlan/${loyaltyPlanId}`,
         method: 'GET',
      })
      if (result.status !== 200) {
         throw new Error(`error ${result.status}`)
      }
      return result.data
   } catch (err) {
      return null as unknown as AccountStatementBannerProps
   }
}
export const saveAccountBannerConfig = async (data: BaseOfferRequest) => {
    const result = await apiCall({
       url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v1/banner`,
       method: data.id ?'PATCH':'POST',
       data,
    })
    return result.data
}
export const sendTryOnEmail = async (data: { emails: string; loyaltyPlanId?: string, id:string }) => {
    const result = await apiCall({
        url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v1/send-email/account-statement/${data.id}?emails=${data.emails}&loyaltyPlanId=${data.loyaltyPlanId}`,
        method: 'POST',
        data,
    })
    return result.data
}